import { combineReducers } from "@reduxjs/toolkit";
import alternativeInvestments from "../features/alternative-investments/store";
import user from "./userSlice";

export default combineReducers({
  alternativeInvestments,
  user: user.reducer,
});
